import { render } from "./OmekaPage.vue?vue&type=template&id=18b7fba4"
import script from "./OmekaPage.vue?vue&type=script&lang=js"
export * from "./OmekaPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__